module.exports = __webpack_public_path__ + "static/media/text_gray.bfe25834.png";